import React, { Component, useState } from "react";
import CartContext from "./CartContext";
import { Products } from "./Products";
import { Showcase } from "./Showcase";
import { Pricing } from "./Pricing";
import { Services } from "./Services";
import Slider from "react-slick";
import { DemoButton } from "./CommonModules";

import { Row, Col, Table, Carousel, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { HomeCarousels } from "./HomeCarosels";
import { ProductHightlights } from "./ProductHighlights";
import Footer from "./Footer";

export class Home extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <HomeCarousels />

        <section className="container py-5">
          <div className="row gx-4">
            <div className="col-12">
              <h2 className="text-primary mb-4 fw-bold">
                Welcome to ElasticCART
              </h2>
              <p className="text-muted" style={{ textAlign: "justify" }}>
                <strong>ElasticCART</strong> is a next-generation ERP software
                platform (Cloud) that delivers a powerful, end-to-end solution
                for a wide range of industries including Manufacturing, Retail,
                Wholesale, Product & Servicing, Hospitality, Hotels &
                Restaurants, Healthcare, Education, Travel, and Logistics.
              </p>
              <p className=" text-muted" style={{ textAlign: "justify" }}>
                Built to streamline your business operations, ElasticCART
                combines enterprise-grade capabilities with a user-friendly
                interface to enhance customer experiences and maximize
                productivity.
              </p>
              <p className=" text-muted" style={{ textAlign: "justify" }}>
                This modern ERP solution is fully cloud-based, reliable, and
                scalable — built for today's dynamic business environment.
              </p>
              <p className=" text-muted" style={{ textAlign: "justify" }}>
                <strong>ElasticCART</strong> is a proprietary platform developed
                and maintained by{" "}
                <a
                  href="https://santreza.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.Santreza.com
                </a>
                .
              </p>
            </div>
            <DemoButton></DemoButton>
          </div>
        </section>

        <ProductHightlights />
        {/* <BusinessSpecificSolution /> */}
        <BenefitsElasticCart />
        <Services />
        <Testimonial1></Testimonial1>
        <ClientsSlider />
        {/* <Footer /> */}
      </>
    );
  }
}

export class BenefitsElasticCart extends Component {
  static contextType = CartContext;

  renderBenefitList() {
    const benefits = [
      "All-in-One Digital Solution for Retail, Wholesale, Supply Chain, Manufacturing, and Enterprise Businesses",
      "Powerful marketing and selling platform",
      "User-friendly, responsive, and device-agnostic",
      "Cloud and elastic hosting with 99.5% uptime",
      "Error-free software with free upgrades",
      "SSL & OTP-based secure authentication",
      "Integrated with Email, SMS, and WhatsApp notifications",
      "3rd-party integration with Swiggy, Zomato",
      "Shiprocket integration (17+ delivery partners including Dunzo)",
      "Premium and customizable eCommerce themes",
      "Powerful filters, AI-based, and fuzzy logic searches",
      "RazorPay / PhonePe integration (custom gateways on request)",
      "Supports single and multi-variant products",
      "Dashboards, analytics, and 360° reports",
      "Excellent customer support",
    ];

    return (
      <ul className="text-muted" style={{ lineHeight: "2em" }}>
        {benefits.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>
    );
  }

  render() {
    const imageSrc =
      "https://ecprdstorage01.blob.core.windows.net/elasticcart/images/benefits.PNG";

    return (
      <div className="container-fluid py-4">
        <div className="container">
          <div className="border-start border-5 border-primary ps-4 mb-4">
            <h6 className="text-primary text-uppercase">Benefits</h6>
            <h2 className="text-uppercase">
              <b>Benefits of ElasticCART</b>
            </h2>
          </div>

          <Row className="align-items-center">
            {/* <Col xs={12} md={6} className="mb-4 mb-md-0 text-center">
              <img
                src={imageSrc}
                alt="Benefits of ElasticCART"
                style={{
                  width: "100%",
                  maxHeight: "600px",
                  objectFit: "contain",
                }}
              />
            </Col> */}
            <Col xs={12} md={6}>
              {this.renderBenefitList()}
            </Col>
            <DemoButton></DemoButton>
          </Row>
        </div>
      </div>
    );
  }
}

export class BusinessSpecificSolution extends Component {
  static contextType = CartContext;

  renderBusinessCard(icon, title, points, link) {
    return (
      <>
        <td width="10%">
          <img src={icon} alt={title} style={{ width: "2cm", height: "2cm" }} />
        </td>
        <td width="90%">
          <h4 className="fw-bold">{title}</h4>
          <ul className="ps-3">
            {points.map((p, i) => (
              <li key={i} style={{ textAlign: "justify" }}>
                {p}
              </li>
            ))}
          </ul>
          <div className="text-end mt-2">
            <a href={link}>
              <Button variant="primary">Learn More</Button>
            </a>
          </div>
        </td>
      </>
    );
  }

  render() {
    const solutions = [
      {
        icon: "/img/retailandwholesale.png",
        title: "Retail & Wholesale Business Solutions",
        points: [
          "ElasticCART is a modern, cloud-based solution for retail and wholesale businesses.",
          "Includes POS billing, eCommerce (B2C & B2B), self-ordering KIOSK/QRCode POS, CRM, order and purchase management, delivery integrations, and more.",
        ],
        link: "/Retail",
      },
      {
        icon: "/img/restaurant.png",
        title: "Restaurant Business Solutions",
        points: [
          "Complete POS system for online and offline restaurant operations.",
          "Includes Captain App, Kitchen Display System (KDS), Table & QR POS, KIOSK, inventory, CRM, Recipe and Delivery apps.",
          "Integrated with Swiggy, Zomato, payment gateways, and delivery systems.",
        ],
        link: "/restaurant",
      },
      {
        icon: "/img/suplychain.png",
        title: "Manufacturing & Supply Chain ERP",
        points: [
          "Covers full supply chain with 12 ERP modules, from raw materials to customer delivery.",
        ],
        link: "/SupplyChain",
      },
    ];

    return (
      <div className="container-fluid py-4">
        <div className="container">
          <div className="border-start border-5 border-primary ps-4 mb-4">
            <h6 className="text-primary text-uppercase">Domain</h6>
            <h2 className="text-uppercase">
              <b>Business Specific Solutions</b>
            </h2>
          </div>

          <Table className="border" responsive>
            <tbody>
              {solutions.map((s, index) => (
                <tr key={index} className="align-middle border">
                  {this.renderBusinessCard(s.icon, s.title, s.points, s.link)}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

export class DemoLinks extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      demoStores: [
        { businessType: "Grocery", storeName: "supermarket" },
        {
          businessType: "Vegetables & Fruits",
          storeName: "fruitsandvegetables",
        },
        { businessType: "Restaurant Multicuisine", storeName: "restaurant" },
        { businessType: "Veg Restaurants", storeName: "vegrestaurant" },
        { businessType: "Fashions", storeName: "fashion" },
        { businessType: "Sarees", storeName: "sarees" },
        { businessType: "Music Instruments", storeName: "Musicstore" },
        { businessType: "Audio Vinyl and CD Store", storeName: "AudioStore" },
        { businessType: "Aquairium & Fish", storeName: "Aquarium" },
        { businessType: "Machinery & Tools", storeName: "Machinery" },
        { businessType: "Mobile Store", storeName: "mobileshop" },
        { businessType: "Electronics", storeName: "electronics" },
        { businessType: "Bakery", storeName: "bakery" },
        { businessType: "Jewellery", storeName: "jewellery" },
        { businessType: "Furniture", storeName: "Furniture" },
        { businessType: "Floral", storeName: "Floral" },
        { businessType: "Books", storeName: "Books" },
        { businessType: "Pharmacy ", storeName: "Pharma" },
        { businessType: "Fish & Meat", storeName: "Meatshop" },
        { businessType: "Plants & Nursery", storeName: "Nursery" },
        { businessType: "Bikes & Cars Accessories", storeName: "BikeNCar" },
        { businessType: "Footwear /Shoe Store", storeName: "Footwear" },
        { businessType: "Sports & Gears", storeName: "Sports" },
      ],
    };
  }

  componentDidMount() {}

  render() {
    return (
      <>
        <div className="py-5">
          <div class="border-start border-5 border-primary ">
            <h6 class="text-primary text-uppercase">Test Sites</h6>
            <h5 class="display-6  mb-0">
              <b>Demo Links </b>
            </h5>
            (Contact our support if require credentials!)
          </div>
          {window.innerWidth > 1200 ? (
            <>
              <Table striped className="">
                <thead>
                  <tr>
                    <th></th>
                    <th>Business Type</th>
                    <th>E-Commerce</th>
                    <th>Point-Of-Sale</th>
                    <th>Admin(ERP) Portal</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.demoStores.map((m, i) => (
                    <>
                      <tr style={{ color: "black" }}>
                        <td>{i + 1}</td>
                        <td className="fw-bold">{m.businessType}</td>
                        <td>
                          <a
                            style={{ color: "blue" }}
                            href={"https://" + m.storeName + ".elasticcart.com"}
                            target="_blank"
                          >
                            {m.storeName + ".elasticcart.com"}
                          </a>
                        </td>
                        <td>
                          <a
                            style={{ color: "blue" }}
                            href={
                              "https://" + m.storeName + "-pos.elasticcart.com"
                            }
                            target="_blank"
                          >
                            {m.storeName + "-pos.elasticcart.com"}
                          </a>
                        </td>
                        <td>
                          <a
                            style={{ color: "blue" }}
                            href={
                              "https://" +
                              m.storeName +
                              "-admin.elasticcart.com"
                            }
                            target="_blank"
                          >
                            {m.storeName + "-admin.elasticcart.com"}
                          </a>
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </Table>
            </>
          ) : (
            <>
              <Table stripped className="">
                <thead>
                  <tr>
                    <th></th>
                    {/* <th>Business Type</th> */}
                    <th>eCommerce, POS, Admin</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.demoStores.map((m, i) => (
                    <>
                      <tr style={{ color: "black" }}>
                        {/* <td className="fw-bold"></td> */}
                        <td>{i + 1}</td>
                        <td>
                          {m.businessType}
                          <br />
                          <a
                            style={{ color: "blue" }}
                            href={"https://" + m.storeName + ".elasticcart.com"}
                            target="_blank"
                          >
                            {m.storeName + ".elasticcart.com"}
                          </a>{" "}
                          <br />
                          <a
                            style={{ color: "blue" }}
                            href={
                              "https://" + m.storeName + "-pos.elasticcart.com"
                            }
                            target="_blank"
                          >
                            {m.storeName + "-pos.elasticcart.com"}
                          </a>
                          <br />
                          <a
                            style={{ color: "blue" }}
                            href={
                              "https://" +
                              m.storeName +
                              "-admin.elasticcart.com"
                            }
                            target="_blank"
                          >
                            {m.storeName + "-admin.elasticcart.com"}
                          </a>
                        </td>
                      </tr>
                    </>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </div>
      </>
    );
  }
}
export class Testimonial extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <>
        <div class="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
          <div class="container py-5">
            <div
              class="section-title text-center position-relative pb-3 mb-4 mx-auto"
              // style={{ maxWidth: "600px;" }}
            >
              <h5 class="fw-bold text-primary text-uppercase">Testimonial</h5>
              <h1 class="mb-0">
                What Our Clients Say About Our Digital Services
              </h1>
            </div>
            <div class=" fadeInUp" data-wow-delay="0.6s">
              <div class="testimonial-item bg-light my-4">
                <div class="ps-4">
                  <h4 class="text-primary mb-1">Mr.Rajan</h4>
                  <small class="text-uppercase">
                    Director of AllSaints Grocery & Bakery
                  </small>
                </div>

                <div class="pt-4 pb-5 px-5">
                  ElasticCART team helped my business sell online under my own
                  brand. My online store got up and running on the same day! I
                  appreciate all your great support. Looking forward to working
                  on other Projects.
                </div>
              </div>
              <div class="testimonial-item bg-light my-4">
                <div class="ps-4">
                  <h4 class="text-primary mb-1">Mr.Ramachandran</h4>
                  <small class="text-uppercase">
                    Director of Pineappleexpress
                  </small>
                </div>

                <div class="pt-4 pb-5 px-5">
                  Now I'm selling products online (B2B and B2C) under my own
                  brand. This is a great feel. My online store looks stunning
                  and great. performance seeing with 5000+ products on my store.
                  Thanks to ElasticCART Team for great solution and support! I
                  am trying to replace my older POS system with ElasticCART's
                  POS now:). I'd recommend it to my friends.
                </div>
              </div>
              <div class="testimonial-item bg-light my-4">
                <div class="ps-4">
                  <h4 class="text-primary mb-1">Mr.Manjunath</h4>
                  <small class="text-uppercase">Director of SpicyHut</small>
                </div>

                <div class="pt-4 pb-5 px-5">
                  We use the total solution of Restaurant Management Solution
                  from ElasticCART. It helps our business go to the next level
                  with powerful POS, eCommerce and KIOSK-based solutions. Our
                  Management productivity improved a lot and we see a lot of
                  savings.
                </div>
              </div>
              <div class="testimonial-item bg-light my-4">
                <div class="ps-4">
                  <h4 class="text-primary mb-1">Mr.Prasanna</h4>
                  <small class="text-uppercase">
                    Director of MGR (Meenakshi Gateway Restaurant)
                  </small>
                </div>

                <div class="pt-4 pb-5 px-5">
                  We are using POS and eCommerce products from ElasticCART. We
                  are happy with the product. Great Support and Kudos to the
                  ElasticCART Support Team for stunning Online Store.
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export class Testimonial1 extends Component {
  static contextType = CartContext;

  render() {
    const testimonials = [
      {
        name: "Mr.Rajan",
        title: "Director of AllSaints Grocery & Bakery",
        content:
          "ElasticCART team helped my business sell online under my own brand. My online store got up and running on the same day! I appreciate all your great support. Looking forward to working on other Projects.",
      },
      {
        name: "Mr.Ramachandran",
        title: "Director of Pineappleexpress Grocery",
        content:
          "Now I'm selling products online (B2B and B2C) under my own brand. My online store looks stunning and handles 5000+ products efficiently. Thanks to ElasticCART for the great solution and support! I'm even switching my POS system to theirs. Highly recommend!",
      },
      {
        name: "Mr.Manjunath",
        title: "Director of SpicyHut",
        content:
          "We use the complete Restaurant Management Solution from ElasticCART. It elevated our operations with POS, eCommerce, and KIOSK integration. Productivity has improved significantly and costs have reduced.",
      },
      {
        name: "Mr.Prasanna",
        title: "Director of MGR (Meenakshi Gateway Restaurant)",
        content:
          "We are happy with ElasticCART’s POS and eCommerce products. Great support and kudos to the team for delivering a stunning online store.",
      },
    ];

    const isMobile = window.innerWidth <= 1200;
    const settings = {
      arrows: false,
      infinite: true,
      slidesToShow: isMobile ? 1 : 3,
      slidesToScroll: 1,
      autoplay: true,
      speed: isMobile ? 1500 : 3000,
      autoplaySpeed: isMobile ? 1500 : 3000,
      cssEase: "linear",
      className: isMobile
        ? "react__slick__slider__parent"
        : "react__slick__slider__parent1",
    };

    return (
      <div className="container-fluid py-5">
        <div className="container py-5">
          <div
            className="section-title text-center position-relative pb-3 mb-4 mx-auto"
            style={{ maxWidth: "600px" }}
          >
            <h5 className="fw-bold text-primary text-uppercase">Testimonial</h5>
            <h2 className="mb-0">
              What Our Clients Say About Our Digital Services
            </h2>
          </div>

          <Slider {...settings}>
            {testimonials.map((item, index) => (
              <div key={index} className="d-flex justify-content-center px-3">
                <Card
                  className="text-dark shadow-sm"
                  style={{
                    width: "18rem",
                    height: "25rem",
                    backgroundColor: "#dfffe0",
                  }}
                >
                  <Card.Body className="d-flex flex-column">
                    <Card.Title>{item.name}</Card.Title>
                    <Card.Subtitle className="mb-3 text-muted">
                      {item.title}
                    </Card.Subtitle>
                    <Card.Text style={{ fontSize: "0.95rem" }}>
                      {item.content}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    );
  }
}

export class ClientsSlider extends Component {
  static contextType = CartContext;

  render() {
    const clientLogos = [
      "allsaints.png",
      "godwill.png",
      "mediuna.png",
      "mgr.png",
      "cura.png",
      "green.png",
      "lifestyleaqua.jpg",
      "pets4you.PNG",
      "rainbow.PNG",
      "pineappleexpress.png",
      "colourconversation.png",
      "genius.png",
      "MaruthamStoreLogo.PNG",
    ];

    const isMobile = window.innerWidth <= 1200;
    const settings = {
      arrows: false,
      infinite: true,
      slidesToShow: isMobile ? 2 : 6,
      slidesToScroll: 1,
      autoplay: true,
      speed: 1000,
      autoplaySpeed: 1000,
      cssEase: "linear",
      className: isMobile
        ? "react__slick__slider__parent"
        : "react__slick__slider__parent1",
    };

    return (
      <div className="text-center px-5 py-4 my-4 border-0 ">
        <div className="px-2 mb-4">
          <h2 className="fw-bold text-uppercase">Our Clients</h2>
        </div>

        <Slider {...settings}>
          {clientLogos.map((logo, index) => (
            <div
              key={index}
              className="d-flex justify-content-center bg-white p-3"
            >
              <img
                src={`https://ecprdstorage01.blob.core.windows.net/elasticcart/images/${logo}`}
                alt={`Client logo ${index + 1}`}
                style={{
                  objectFit: "contain",
                  width: "4cm",
                  height: "3cm",
                }}
              />
            </div>
          ))}
        </Slider>
        <br />
        <div className="container-fluid facts py-2 pt-lg-0">
          <div className="container py-5 pt-lg-0">
            <div className="row gx-0">
              {[
                {
                  icon: "fa-users",
                  title: "Happy Clients",
                  count: 350,
                  color: "primary",
                },
                {
                  icon: "fa-check",
                  title: "Projects Done",
                  count: 375,
                  color: "light",
                },
                {
                  icon: "fa-award",
                  title: "Experience",
                  count: 25,
                  color: "primary",
                },
              ].map((item, index) => (
                <div
                  key={item.title}
                  className="col-lg-4 wow zoomIn"
                  data-wow-delay={`${0.1 + index * 0.2}s`}
                >
                  <div
                    className={`bg-${item.color} shadow d-flex align-items-center justify-content-center p-4`}
                    style={{ height: "150px" }}
                  >
                    <div
                      className={`${
                        item.color === "light" ? "bg-primary" : "bg-white"
                      } d-flex align-items-center justify-content-center rounded mb-2`}
                      style={{ width: "60px", height: "60px" }}
                    >
                      <i
                        className={`fa ${item.icon} ${
                          item.color === "light" ? "text-white" : "text-primary"
                        }`}
                      ></i>
                    </div>
                    <div className="ps-4">
                      <h5
                        className={`mb-0 ${
                          item.color === "light" ? "text-primary" : "text-white"
                        }`}
                      >
                        {item.title}
                      </h5>
                      <Row>
                        <Col>
                          <h1
                            className={`mb-0 ${
                              item.color === "light" ? "" : "text-white"
                            }`}
                            data-toggle="counter-up"
                          >
                            {item.count}
                          </h1>
                        </Col>
                        <Col>
                          <h1
                            className={`mb-0 ${
                              item.color === "light" ? "" : "text-white"
                            }`}
                          >
                            +
                          </h1>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
